import styled from '@emotion/styled'
import { css } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'

export const Container = styled('form')`
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.md};
  border-radius: ${theme.shapes.borderRadius.md};
  display: flex;
  flex-direction: column;
  margin-bottom: ${theme.spacing.md};
`

export const WrapperHeader = styled.div`
  display: flex;
  flex-direction: column;
`
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${theme.spacing.sm};
`
export const HeaderItem = styled.div`
  display: flex;
  flex-direction: column;
  h1 {
    margin: 0;
    font-size: ${theme.typography.sizes['3md']};
  }

  @media screen and (max-width: ${theme.breakpoints.lg}px) {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

export const StructureInputs = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  margin-right: ${theme.spacing.xs};
`

export const SelectorWrapper = styled.div`
  display: flex;
  min-width: 220px;
  justify-content: flex-end;

  @media screen and (max-width: ${theme.breakpoints.lg}px) {
    min-width: auto;
  }
`

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

type LabelFilterProps = { disabled?: boolean }

type FormFieldProps = {
  lastItem?: boolean
  flex?: boolean
}

export const FormField = styled.div<FormFieldProps>`
  display: ${({ flex }) => (flex ? 'flex' : 'grid')};
  grid-template-columns: 80px minmax(80px, 1fr);
  gap: 8px;

  ${({ lastItem }) => css`
    grid-column: ${lastItem ? '5' : 'unset'};
    @media screen and (max-width: ${theme.breakpoints.lg}px) {
      grid-column: ${lastItem ? '2' : 'unset'};
    }
  `}
`

export const LabelFilter = styled.div<LabelFilterProps>`
  display: flex;
  color: ${theme.colors.neutral.high};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes['2xs']};
  gap: ${theme.spacing.xs};
  align-items: center;
  white-space: nowrap;

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${theme.colors.neutral.medium};
    `}
`
export const FilterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(100px, 1fr));

  column-gap: ${theme.spacing.sm};
  row-gap: ${theme.spacing.sm};
  align-items: center;

  @media screen and (max-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }
`

export const WrapHierarchyField = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
`

export const ClearFiltersWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`

export const WrapTitleWithButton = styled.div`
  display: flex;
  gap: ${theme.spacing.xs};
  align-items: flex-end;

  h1 {
    font-size: ${theme.typography.sizes['2md']};
  }
`

export const HorDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.quartenary};
  margin: ${theme.spacing.sm} 0;
`

export const MultiSelectWrapper = styled.div`
  display: flex;
  width: 100%;
`

export const ClientSapWrapper = styled.div`
  display: flex;
  gap: 4px;
`
